export function validateFrequency ({frequencyValue}) {
  return frequencyValue.match(/^\d+[+-]?$/);
}
